import { Food, IngredientFood } from '../../../../core/db_food'

export function changeCustomTag(tagMode: 'none' | 'save' | 'replace', tag: string, orgFoods: Food[]): Food[] {
    const replacedFoods = tagMode == 'none' || (tagMode == 'replace' && tag.trim().length == 0)
        ? removeTagFromFood
        : tagMode == 'replace'
            ? (food: Food) => replaceTagInFood(food, tag)
            : (food: Food) => addTagToFood(food, tag)
    return orgFoods.map(replacedFoods) as Food[]
}

type FoodOrIngredientFood = Food | IngredientFood
function removeTagFromFood(food: FoodOrIngredientFood): FoodOrIngredientFood {
    const newFood = { ...food }
    newFood.name = newFood.name.replace(/{([^}]+)}/, '')
    return newFood
}
function replaceTagInFood(food: FoodOrIngredientFood, newTag: string): FoodOrIngredientFood {
    const newFood = { ...food }
    // вытаскиваем текущий тег из измененного продукта, если он есть
    const currentTag = newFood.name.match(/{([^}]+)}/)?.[1]
    // console.log('currentTag', currentTag, newFood.name.match(/{([^}]+)}/))
    if (currentTag) {
        newFood.name = newFood.name.replace(`{${currentTag}}`, `{${newTag}}`)
    } else {
        newFood.name = `${newFood.name} {${newTag}}`
    }
    // Проверка, что объект является Food, а не IngredientFood — наличие поля 'm'
    if ('m' in newFood) {
        if (newFood.m) {
            newFood.mc = newFood.mc.map(ingredient => replaceTagInFood(ingredient, newTag) as IngredientFood)
        }
        return newFood as Food
    }
    return newFood
}
function addTagToFood(food: FoodOrIngredientFood, newTag: string): FoodOrIngredientFood {
    if (newTag.trim().length == 0) {
        return food
    }
    const newFood = { ...food }
    // вытаскиваем текущий тег из измененного продукта, если он есть
    const currentTag = newFood.name.match(/{([^}]+)}/)?.[1]
    if (currentTag) {
        newFood.name = newFood.name.replace(`{${currentTag}}`, `{${currentTag};${newTag}}`)
    } else {
        newFood.name = `${newFood.name} {${newTag}}`
    }
    if ('m' in newFood) {
        if (newFood.m) {
            newFood.mc = newFood.mc.map(ingredient => addTagToFood(ingredient, newTag) as IngredientFood)
        }
        return newFood as Food
    }
    return newFood
}